<!-- Footer -->
<footer class="text-black w-100" style="background-color: #F6F6F6;">
  <p class="text-center w-100">
    © 2022 Beberia. All rights reserved
  </p>
</footer>
<!-- Footer -->
